/*!
 * Link HTML attributes (e.g. ko-handler-name) to binding handlers 🥊  tko.provider.attr@4.0.0-alpha5c
 * (c) The Knockout.js Team - https://tko.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { Provider } from 'tko.provider';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/**
 * Convert attributes with ko-* to bindings.
 *
 * e.g.
 * <div ko-visible='value'></div>
 */
var AttrProvider = /** @class */ (function (_super) {
    __extends(AttrProvider, _super);
    function AttrProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AttrProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [1]; } // document.ELEMENT_NODE
        ,
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AttrProvider.prototype, "PREFIX", {
        get: function () { return 'ko-'; },
        enumerable: true,
        configurable: true
    });
    AttrProvider.prototype.getBindingAttributesList = function (node) {
        var _this = this;
        if (!node.hasAttributes()) {
            return [];
        }
        return Array.from(node.attributes)
            .filter(function (attr) { return attr.name.startsWith(_this.PREFIX); });
    };
    AttrProvider.prototype.nodeHasBindings = function (node) {
        return this.getBindingAttributesList(node).length > 0;
    };
    AttrProvider.prototype.getBindingAccessors = function (node, context) {
        return Object.assign.apply(Object, __spread([{}], this.handlersFromAttributes(node, context)));
    };
    AttrProvider.prototype.handlersFromAttributes = function (node, context) {
        var e_1, _a, _loop_1, this_1, _b, _c, attr, e_1_1;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _loop_1 = function (attr) {
                        var _a, name_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    name_1 = attr.name.substr(this_1.PREFIX.length);
                                    return [4 /*yield*/, (_a = {}, _a[name_1] = function () { return _this.getValue(attr.value, context, node); }, _a)];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    this_1 = this;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    _b = __values(this.getBindingAttributesList(node)), _c = _b.next();
                    _d.label = 2;
                case 2:
                    if (!!_c.done) return [3 /*break*/, 5];
                    attr = _c.value;
                    return [5 /*yield**/, _loop_1(attr)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _c = _b.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    };
    AttrProvider.prototype.getValue = function (token, $context, node) {
        /* FIXME: This duplicates Identifier.prototype.lookup_value; it should
           be refactored into e.g. a BindingContext method */
        if (!token) {
            return;
        }
        var $data = $context.$data;
        switch (token) {
            case '$element': return node;
            case '$context': return $context;
            case 'this':
            case '$data': return $context.$data;
        }
        if ($data instanceof Object && token in $data) {
            return $data[token];
        }
        if (token in $context) {
            return $context[token];
        }
        if (token in this.globals) {
            return this.globals[token];
        }
        throw new Error("The variable '" + token + " not found.");
    };
    return AttrProvider;
}(Provider));

export { AttrProvider as AttributeProvider };
//# sourceMappingURL=tko.provider.attr.js.map
